import { render, staticRenderFns } from "./latest_invoice.vue?vue&type=template&id=dab179e2&scoped=true"
import script from "./latest_invoice.vue?vue&type=script&lang=js"
export * from "./latest_invoice.vue?vue&type=script&lang=js"
import style0 from "./latest_invoice.vue?vue&type=style&index=0&id=dab179e2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab179e2",
  null
  
)

export default component.exports